// extracted by mini-css-extract-plugin
export default {"messageItem":"MessageItem_messageItem__uxV9M","outgoingMessage":"MessageItem_outgoingMessage__AqYdo","smsAutomatedOptMessage":"MessageItem_smsAutomatedOptMessage__fj0LR"};